import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  VStack,
  HStack,
  Text
} from '@chakra-ui/react';

const IntentSelector = ({ selectedIntent, onIntentChange }) => {
  const intentOptions = [
    {
      id: 'context',
      title: 'Tell me something first',
      subtitle: 'Share vibe, occasion or style direction',
      icon: '💬'
    },
    {
      id: 'fast',
      title: 'Just find products', 
      subtitle: 'Skip straight to recommendations',
      icon: '⚡'
    }
  ];

  return (
    <VStack spacing={4} align="stretch" w="100%">
   
      
      <HStack spacing={4} justify="center" w="100%">
        {intentOptions.map((option) => (
          <motion.div
            key={option.id}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex-1"
          >
            <Box
              as="button"
              onClick={() => onIntentChange(option.id)}
              w="100%"
              p={6}
              borderRadius="xl"
              border="2px solid"
              borderColor={selectedIntent === option.id ? "#54524e" : "#fef8ed"}
              bg={selectedIntent === option.id ? "#fef7ed" : "#f8d1af"}
              _hover={{
                borderColor: "blue.400",
                bg: "blue.25",
                shadow: "lg"
              }}
              transition="all 0.2s ease"
              cursor="pointer"
              textAlign="center"
              minH="120px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <VStack spacing={2}>
                <Text fontSize="2xl" mb={1}>
                  {option.icon}
                </Text>
                <Text 
                  fontWeight="bold" 
                  fontSize="md"
                  color={selectedIntent === option.id ? "#862f44" : "gray.800"}
                >
                  {option.title}
                </Text>
                <Text 
                fontWeight="semibold"
                  fontSize="sm" 
                  color={selectedIntent === option.id ? "#924457" : "gray.600"}
                  lineHeight="short"
                >
                  {option.subtitle}
                </Text>
              </VStack>
            </Box>
          </motion.div>
        ))}
      </HStack>
    </VStack>
  );
};

export default IntentSelector;